<template>
    <div>
        <el-card class="box-card" v-loading="loading">
            <el-form :model="customerChange" ref="customerChangeRef" label-width="82px">
                <el-form-item label="姓名" class="addAdminForm">
                    <el-input v-model="customerChange.name" placeholder="请输入用户姓名"></el-input>
                </el-form-item>
                <el-form-item label="年龄" class="addAdminForm">
                    <el-input v-model="customerChange.age" placeholder="请输入用户年龄"></el-input>
                </el-form-item>
                <el-form-item label="性别" class="addAdminForm">
                    <el-radio v-model="customerChange.sex" label="1">男</el-radio>
                    <el-radio v-model="customerChange.sex" label="2">女</el-radio>
                </el-form-item>
                <el-form-item label="速度档位" class="speed">
                    <el-select v-model="customerChange.speedstate" placeholder="请选择" style="width: 100%">
                        <el-option label="高" value="1"></el-option>
                        <el-option label="中" value="2"></el-option>
                        <el-option label="低" value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="联系方式" class="addAdminForm">
                    <el-input v-model="customerChange.phone" placeholder="请输入手机号码"></el-input>
                </el-form-item>
                <el-form-item label="IP限制" class="speed">
                    <el-select v-model="customerChange.iplimit" placeholder="请选择" style="width: 100%">
                        <el-option label="限制" value="1"></el-option>
                        <el-option label="开放" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="省市区" class="addAdminForm">
                  <el-select v-model="customerChange.province" placeholder="请选择省" class="select1" @change="changeprovince">
                    <el-option
                      v-for="item in optionsprovince" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select v-model="customerChange.city" collapse-tags  class="select1" placeholder="请选择市" @change="changecity">
                    <el-option
                      v-for="item in optionscity" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select v-model="customerChange.area" collapse-tags  class="select1" placeholder="请选择区" style="margin: 0">
                    <el-option
                      v-for="item in optionsarea" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="常用地址" class="addAdminForm">
                    <el-input v-model="customerChange.address" placeholder="请输入详细地址"></el-input>
                </el-form-item>
                <el-form-item label="归属机构" class="addAdminForm">
                    <Rsljigou :propsjigouid="customerChange.jigouid" :propsjigouname="customerChange.jigouname" @change="changeRsljigou"></Rsljigou>
                    <p>更改归属机构之前请先解绑</p>
                    <el-button type="success" plain @click="clickunbind">解绑</el-button>
                </el-form-item>
                <el-form-item label="新密码" class="addAdminForm">
                    <el-input v-model="customerChange.newpassword" type="password" placeholder="请输入密码"></el-input>
                </el-form-item>
                <el-form-item class="mt20">
                    <el-button type="primary" @click="clicksave">保存</el-button>
                    <el-button type="info" @click="backCustomerManagement">返回</el-button>
                </el-form-item>
            </el-form>

            <div class="title mt20">IP限制修改记录</div>
            <el-table :data="listlog" border stripe class="mt15">
              <el-table-column prop="CityChange" label="省市"></el-table-column>
              <el-table-column prop="IpLimitChange" label="IP限制"></el-table-column>
              <el-table-column prop="Adminname" label="操作人员"></el-table-column>
              <el-table-column prop="Createtime" label="操作时间"></el-table-column>
            </el-table>

        </el-card>
    </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou
  },
  data () {
    return {
      loading: false,
      customerChange: {
        name: '',
        age: '',
        sex: '1',
        speedstate: '1',
        iplimit: '1',
        phone: '',
        province: '2',
        city: '2',
        area: '2',
        address: '',
        jigouid: '0',
        jigouname: '',
        newpassword: ''
      },
      optionsprovince: [],
      optionscity: [],
      optionsarea: [],
      // 选择机构
      select: {
        keywords: ''
      },
      radio: '1',
      parentdata: null,
      listlog: []
    }
  },
  mounted () {
    this.apigetregionlist(1, 1)

    var that = this
    setTimeout(function () {
      that.customerChange.newpassword = ''
    }, 1000)
  },
  methods: {
    LoadData (parentdata) {
      this.parentdata = parentdata
      this.apigetcustomereditinfo()
      this.apiGetglassuserchangeiplimit()
    },
    backCustomerManagement () {
      this.$emit('triggerFunc', '')
    },
    changeRsljigou (vid, vname) {
      this.customerChange.jigouid = vid
      this.customerChange.jigouname = vname
    },
    clickunbind () {
      this.apieditcustomerunbind()
    },
    clicksave () {
      this.apieditcustomereditinfo()
    },
    changeprovince (data) {
      this.apigetregionlist(2, data)
    },
    changecity (data) {
      this.apigetregionlist(3, data)
    },
    apigetregionlist: function (type, parentid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        parentid: parentid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getregionlist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            if (type == 1) {
              that.optionsprovince = []
              response.data.List.filter((item, i) => {
                that.optionsprovince.push({ value: item.Id, label: item.Name })
              })
            }
            if (type == 2) {
              that.optionscity = []
              response.data.List.filter((item, i) => {
                that.optionscity.push({ value: item.Id, label: item.Name })
              })
            }
            if (type == 3) {
              that.optionsarea = []
              response.data.List.filter((item, i) => {
                that.optionsarea.push({ value: item.Id, label: item.Name })
              })
            }
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apigetcustomereditinfo: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getcustomereditinfo, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.customerChange.name = response.data.Name
            that.customerChange.age = response.data.Age
            that.customerChange.sex = response.data.Sex
            that.customerChange.speedstate = response.data.Speedstate
            that.customerChange.iplimit = response.data.Iplimit.toString()
            that.customerChange.phone = response.data.Phone
            that.customerChange.province = response.data.Province
            that.customerChange.city = response.data.City
            that.customerChange.area = response.data.Area
            that.customerChange.address = response.data.Address
            that.customerChange.jigouid = response.data.Jigouid
            that.customerChange.jigouname = response.data.Jigouname

            that.apigetregionlist(2, response.data.Province)
            that.apigetregionlist(3, response.data.City)
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apiGetglassuserchangeiplimit: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getglassuserchangeiplimit, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.listlog = response.data.List
          }
          console.log(response.data)
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apieditcustomereditinfo: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid,
        name: this.customerChange.name,
        age: this.customerChange.age,
        sex: this.customerChange.sex,
        speedstate: this.customerChange.speedstate,
        iplimit: this.customerChange.iplimit,
        phone: this.customerChange.phone,
        province: this.customerChange.province,
        city: this.customerChange.city,
        area: this.customerChange.area,
        address: this.customerChange.address,
        jigouid: this.customerChange.jigouid,
        newpassword: this.customerChange.newpassword
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editcustomereditinfo, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
          that.apiGetglassuserchangeiplimit()
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apieditcustomerunbind: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editcustomerunbind, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.select1 {
    width: 109px;
    margin-right: 15px;
}
.speed {
    width: 440px;
    margin-right: 15px;
}
</style>
